import { render } from "./Transcription.vue?vue&type=template&id=23a140ac&scoped=true&ts=true"
import script from "./Transcription.vue?vue&type=script&lang=ts"
export * from "./Transcription.vue?vue&type=script&lang=ts"

import "./Transcription.vue?vue&type=style&index=0&id=23a140ac&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a140ac"]])

export default __exports__